import Api from '@/providers/Api';

export const SET_SOCIETY_CERTIFYING_BOARDS_MUTATION = 'SET_SOCIETY_CERTIFYING_BOARDS_MUTATION';
export const GET_SOCIETY_CERTIFYING_BOARDS_ACTION = 'GET_SOCIETY_CERTIFYING_BOARDS_ACTION';

export default {
  state: () => ({
    items: [],
  }),
  getters: {},
  mutations: {
    [SET_SOCIETY_CERTIFYING_BOARDS_MUTATION]: function (state, boards) {
      state.items = boards;
    },
  },
  actions: {
    [GET_SOCIETY_CERTIFYING_BOARDS_ACTION]: async function ({ commit }) {
      const response = await Api.getSocietyCertifyingBoards();
      commit(
        SET_SOCIETY_CERTIFYING_BOARDS_MUTATION,
        response.items
      );
    },
  },
};
